import Affiliates from '../Afiliados';

export default function Sponsors() {
    return <Affiliates sponsorsOnly />;
}
